import { FieldValue } from "api/firebase";
import orderRefs from "api/shows/orders/refs";
import { OrderStatus } from "ts/api/order";
import { PaymentMethodType } from "ts/api/paymentMethod";

type ResetQuickOrderPaymentAttemptParams = {
  showId: string;
  orderId: string;
};

export const getQuickOrderPaymentAttemptReset = () => ({
  "paymentDetails.status": OrderStatus.awaitingPayment,
  paymentType: PaymentMethodType.notSelected,
  transfers: FieldValue.delete(),
  paymentIntentId: FieldValue.delete(),
});

export const resetQuickOrderPaymentAttempt = async ({
  showId,
  orderId,
}: ResetQuickOrderPaymentAttemptParams) => {
  await orderRefs
    .getDocument({
      showId,
      orderId,
    })
    .update(getQuickOrderPaymentAttemptReset());
};
